// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__Kntsu","clickableCard":"styles_clickableCard__bEQ3S"};